/** Company domains a test reminder may go to (E13). The server checks the same list. */
export const REMINDER_TEST_DOMAINS = ['@dolder.com', '@dolderbigler.com'] as const;

const SIMPLE_ADDRESS = /^[^\s@<>(),;:"[\]\\]+@[^\s@<>(),;:"[\]\\]+$/;

/** true for one plain address on @dolder.com or @dolderbigler.com (case-insensitive, trimmed). */
export function isReminderTestAddress(value: string | null | undefined): boolean {
    const v = (value ?? '').trim().toLowerCase();
    if (!SIMPLE_ADDRESS.test(v)) return false;
    return REMINDER_TEST_DOMAINS.some(d => v.endsWith(d) && v.length > d.length);
}
